import styled from 'styled-components';

export const Isin = styled.div`
  line-height: 24px;
`;
